import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmContractTemplateVO {
  id?: number
  name: string
  content: string
  enabled?: boolean
  createTime?: string
}

export interface FirmContractTemplatePageReqVO extends PageParam {
  name?: string
  enabled?: boolean
}

export const FirmContractTemplateApi = {
  page: async (
    params: FirmContractTemplatePageReqVO
  ): Promise<PageResult<FirmContractTemplateVO>> =>
    request.get({ url: '/lawyer/firm/contract-template/page', params }),
  get: async (id: number): Promise<FirmContractTemplateVO> =>
    request.get({ url: '/lawyer/firm/contract-template/get', params: { id } }),
  create: async (data: FirmContractTemplateVO): Promise<number> =>
    request.post({ url: '/lawyer/firm/contract-template/create', data }),
  update: async (data: FirmContractTemplateVO): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/contract-template/update', data }),
  updateEnabled: async (data: { id: number; enabled: boolean }): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/contract-template/update-enabled', data })
}

/** 运营可见名称；落库仍用 {{token}}，后端按 token 替换 */
export const TEMPLATE_FIELDS = [
  { token: 'customerName', label: '委托人姓名', sample: '张三' },
  { token: 'matterTitle', label: '案件标题', sample: '劳动争议委托代理' },
  { token: 'amount', label: '合同金额', sample: '20000' },
  { token: 'firmCaseNo', label: '所内案号', sample: 'MF-20261006-0001' }
] as const

export const TEMPLATE_VARIABLES = TEMPLATE_FIELDS.map((f) => `{{${f.token}}}`)

const TOKEN_RE = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g

export function templateTokenToChip(token: string) {
  return `【${TEMPLATE_FIELDS.find((f) => f.token === token)?.label || token}】`
}

export function toEditorContent(raw?: string) {
  return String(raw || '').replace(TOKEN_RE, (_, token: string) => templateTokenToChip(token))
}

export function toStoredContent(editor?: string) {
  let text = String(editor || '')
  for (const field of TEMPLATE_FIELDS) {
    text = text.replaceAll(`【${field.label}】`, `{{${field.token}}}`)
  }
  return text
}

export function previewTemplateContent(editorOrStored?: string) {
  let text = toEditorContent(editorOrStored)
  for (const field of TEMPLATE_FIELDS) {
    text = text.replaceAll(`【${field.label}】`, field.sample)
  }
  return text
}
